import { DownloadResultLimiter } from "@/services/license/license-limiters/base-limiters/download-result-limiter";
import { LicenseName } from "@/data/license.data";

export class AiMasteringDownloadResultLimiter extends DownloadResultLimiter {
  isDownloadEnabled(license: LicenseName) {
    return license === "Studio";
  }
}
